import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck } from '@fortawesome/pro-light-svg-icons'
export default function WhyChooseUs() {

    return (
        <span className="sidebar-component green-background">
            <p className="sidebar-header">Why choose us</p>
            <span className="sidebar-component-container">
                <span className="sidebar-item"><FontAwesomeIcon className="tick-icon" icon={faCircleCheck} /> Excellent UK customer service</span>
                <span className="sidebar-item"><FontAwesomeIcon className="tick-icon" icon={faCircleCheck} /> Tailored insurance cover</span>
                <span className="sidebar-item"><FontAwesomeIcon className="tick-icon" icon={faCircleCheck} /> Online documents</span>
                <span className="sidebar-item"><FontAwesomeIcon className="tick-icon" icon={faCircleCheck} /> Instant cover available</span>
            </span>
        </span>
    )

}